import React from "react";
import { ReactTitle } from "react-meta-tags";

const PageTitle = ({ title }) => <ReactTitle title={`${title || ""} | ${process.env.REACT_APP_NAME}`} />;

export default PageTitle;
